import { defineStore } from 'pinia';
import {
	type Category,
	type CategoryKey,
} from '../components/ReportsLibrary/types';
import { type ReportsLibraryReport } from '@/generated/graphql';
import { ReportCategoryNames } from '../components/ReportsLibrary/constants';

export const useReportsLibraryStore = defineStore('reportsLibrary', {
	state: () => {
		return {
			categories: [] as Array<Category>,
			reports: [] as Array<ReportsLibraryReport>,
			isModalOpen: false,
			selectedCategory: ReportCategoryNames.EMPTY as CategoryKey,
		};
	},
});
